<ng-container *transloco="let t">
  <ng-template #headerTpl>
    @if (dialogData?.svgIcon || dialogData?.icon) {
    <div
      class="size-10 rounded-lg flex items-center justify-center shrink-0"
      [class.bg-danger-surface-tint]="dialogData!.iconVariant === 'danger'"
      [class.text-danger]="dialogData!.iconVariant === 'danger'"
      [class.bg-warning-surface]="dialogData!.iconVariant === 'warning'"
      [class.text-warning]="dialogData!.iconVariant === 'warning'"
      [class.bg-primary-soft]="!dialogData!.iconVariant || dialogData!.iconVariant === 'primary'"
      [class.text-primary]="!dialogData!.iconVariant || dialogData!.iconVariant === 'primary'"
    >
      @if (dialogData!.svgIcon) {
      <mat-icon [svgIcon]="dialogData!.svgIcon" class="size-6!" />
      } @else {
      <mat-icon class="size-6!">{{ dialogData!.icon }}</mat-icon>
      }
    </div>
    }
    <div class="flex flex-col gap-0.5">
      <h2 class="text-base font-semibold text-ink-strong">{{ t(dialogData!.title) }}</h2>
      @if (dialogData?.subtitle) {
      <p class="text-xs text-ink-tertiary">{{ t(dialogData!.subtitle || '') }}</p>
      }
    </div>
  </ng-template>

  <dss-libs-ui-base-modal
    [header]="headerTpl"
    [primaryTitle]="dialogData?.primaryButtonLabel || 'GENERAL.CONFIRM'"
    [secondaryTitle]="dialogData?.secondaryButtonLabel || 'GENERAL.CANCEL'"
    [primaryButtonColor]="dialogData?.primaryButtonColor || 'primary'"
    [secondaryButtonColor]="dialogData?.secondaryButtonColor || 'gray'"
    (primarySubmitted)="confirm()"
    (secondarySubmitted)="closeModal()"
    (closed)="closeModal()"
  >
    @if (dialogData?.participant || dialogData?.message || dialogData?.callout) {
    <div class="flex flex-col gap-3.5 px-6 py-5">
      @if (dialogData?.participant) {
      <div class="flex items-center gap-3 p-3.5 rounded-lg bg-surface-subtle">
        <div
          class="size-9 rounded-full bg-primary text-white flex items-center justify-center text-sm font-semibold shrink-0"
        >
          {{ initials() }}
        </div>
        <div class="flex flex-col gap-0.5 min-w-0">
          <span class="text-sm font-semibold text-ink-strong truncate">{{ dialogData!.participant!.name }}</span>
          <span class="text-xs text-ink-tertiary truncate">{{ dialogData!.participant!.email }}</span>
        </div>
      </div>
      } @if (dialogData?.message) {
      <p class="text-sm text-ink-secondary">{{ t(dialogData!.message || '', dialogData?.messageParams || {}) }}</p>
      } @if (dialogData?.callout) {
      <div
        class="text-sm text-ink-secondary rounded-lg px-3 py-2"
        [class.bg-warning-surface-tint]="dialogData!.calloutVariant !== 'danger'"
        [class.bg-danger-surface-tint]="dialogData!.calloutVariant === 'danger'"
      >
        {{ t(dialogData!.callout || '', dialogData?.calloutParams || {}) }}
      </div>
      }
    </div>
    }
  </dss-libs-ui-base-modal>
</ng-container>
